<template>
  <div>
    <b-card no-body>
      <b-card-header header-tag="header" role="tab">
        <h5 v-b-toggle.accordion-1 class="m-0">
          {{ $t('Filter') }}
          <span class="badge bg-light ms-1">{{ filterColumns.length }}</span>
        </h5>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="filter-accordion" role="tabpanel">
        <b-card-body>
          <div v-for="(column, key) in filterColumns" :key="key+'1'" class="row g-2 mb-3">
            <div class="col-4 col-md-2">
              <b-select :value="column.key || ''" @change="onKeyChange(column, $event)" :options="[
                  { value: '', text: '' },
                  ...Object.keys(columns).map((k) => ({ value: k, text: columns[k].label }))]">
              </b-select>
            </div>
            <div class="col-4 col-md-2">
              <b-select
                  v-if="(columns[column.key] || {}).type === Number && column.key === 'nominal'"
                  :value="column.operator" @change="$set(column, 'operator', $event); $delete(column, 'value')"
                  :options="[
                    { value: 'between', text: 'Between' }
                ]"
              ></b-select>
              <b-select
                  v-else-if="(columns[column.key] || {}).type === Number"
                  :value="column.operator" @change="$set(column, 'operator', $event); $delete(column, 'value')"
                  :options="[
                    { value: 'eq', text: '=' }
                ]"
                  disabled
              ></b-select>
              <b-select
                v-if="(columns[column.key] || {}).type === String"
                :value="column.operator" @change="$set(column, 'operator', $event); $delete(column, 'value')"
                :options="options"></b-select>
              <b-select
                v-else-if="(columns[column.key] || {}).type === Date"
                :value="column.operator" @change="$set(column, 'operator', $event); ['null', 'not_null'].includes($event) && $set(column, 'value', ($event && 1) || $delete(column, 'value'))"
                :options="[
                  // {value: '', text: $t('No Filter')},
                  {value: 'gte', text: '>='},
                  {value: 'lte', text: '<='},
                  {value: 'between', text: 'Between'},
                  {value: 'null', text: $t('Null')},
                  {value: 'not_null', text: $t('Not Null')},
                ]"></b-select>
              <b-select
                v-else-if="(columns[column.key] || {}).type === Array"
                :value="column.operator" @change="$set(column, 'operator', $event); $set(column, 'value', ($event && 1) || undefined)"
                :options="[
                  // {value: '', text: $t('No Filter')},
                  {value: 'has', text: $t('Has')},
                  {value: 'doesnt_have', text: $t('Doesnt Have')},
                ]"></b-select>
            </div>
            <div class="col-4 col-md-4">
              <range-price v-if="(columns[column.key] || {}).type === Number && column.key === 'nominal'"
                           @change="$set(column, 'value', $event)"/>
              <b-select
                  v-else-if="(columns[column.key] || {}).type === String && column.operator && modelVariable === 'ticket' && column.key === 'customer_type'"
                  :value="column.value"
                  @change="$set(column, 'value', $event)"
                  :options="[
                  {value: 'brs', text: 'Big Regional Sales'},
                  {value: 'lcs', text: 'Local Supplier'},
                ]">
              </b-select>
              <b-select
                  v-else-if="(columns[column.key] || {}).type === String && column.operator && modelVariable === 'ticket' && column.key === 'status'"
                  :value="column.value"
                  @change="$set(column, 'value', $event)"
                  :options="[
                  {value: 'open', text: 'True'},
                  {value: 'close', text: 'False'},
                ]">
              </b-select>
              <b-input v-else-if="(columns[column.key] || {}).type === String && column.operator" :value="column.value" @update="$set(column, 'value', $event)" :debounce="500" />
              <b-input v-else-if="[String, Number].includes((columns[column.key] || {}).type) && column.operator"
                       :value="column.value" @update="$set(column, 'value', $event)" :debounce="500" />
              <datepicker v-else-if="(columns[column.key] || {}).type === Date && column.operator !== 'between'" v-model="column.value"/>
              <datepicker
                v-else-if="(columns[column.key] || {}).type === Date && column.operator === 'between'"
                :value="(column.value || '').split(',')"
                @input="(dates) => $set(column, 'value', dates.join(','))"
                format="YYYY-MM-DD"
                type="date"
                :range="true"
              />
            </div>
            <div class="col">
              <div class="float-end">
                <b-button size="sm" tag="span" variant="link" class="text-danger" @click="removeFilter(key)">{{ $t('Delete') }}</b-button>
              </div>
            </div>
          </div>
          <div>
            <b-button size="sm" tag="span" variant="link" @click="addFilter">+ {{ $t('Add {something}', { something: 'Filter' }) }}</b-button>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "@/components/inputs/datepicker";
import RangePrice from "@/components/inputs/range-price";

export default {
  name: "model-filter",
  components: {
    RangePrice,
    Datepicker
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    columns: {
      type: Object,
      default() {
        return {
          name: {
            label: this.$t('Name'),
            type: String
          }
        }
      }
    },
    modelVariable: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filterColumns: Object.keys(this.value || {}).map((key) => ({
        key: key.split('__').shift(),
        operator: key.split('__').pop(),
        value: this.value[key]
      })),

      valueWatch: true,
      filterColumnsWatch: true,
    }
  },
  computed: {
    options() {
      if (this.modelVariable === 'ticket') {
        return [
          { value: '', text: this.$t("No Filter") },
          { value: 'contains', text: this.$t("Include") }
        ]
      } else {
        return [
          {value: '', text: this.$t('No Filter')},
          {value: 'begins_with', text: this.$t('Begins With')},
          {value: 'contains', text: this.$t('Contains')},
          {value: 'ends_with', text: this.$t('Ends With')},
          {value: 'eq', text: this.$t('Match Exactly')},
        ]
      }
    }
  },
  watch: {
    value() {
      if (!this.valueWatch) return;
      this.filterColumnsWatch = false;
      this.filterColumns = Object.keys(this.value || {}).map((key) => ({
        key: key.split('__').shift(),
        operator: key.split('__').pop(),
        value: this.value[key]
      }));
      this.$nextTick(() => {
        this.filterColumnsWatch = true;
      })
    },
    filterColumns: {
      handler(vals) {
        if (!this.filterColumnsWatch) return;
        this.valueWatch = false;
        let value = {};
        (vals || []).forEach((val) => {
          value[[val.key, ...(val.operator ? [val.operator] : [])].join('__')] = val.value === '' ? undefined : (val.value);
        })
        this.$emit('change', JSON.parse(JSON.stringify(value)))
        this.$nextTick(() => {
          this.valueWatch = true;
        })
      },
      deep: true
    }
  },
  methods: {
    addFilter() {
      this.filterColumns.push({})
    },
    removeFilter(index) {
      this.filterColumns.splice(index, 1)
    },
    onKeyChange(column, event) {
      this.$set(column, 'key', event);
      this.$delete(column, 'value')

      if ((this.columns[column.key] || {}).type === Number) {
        this.$set(column, 'operator', 'eq');
      } else {
        this.$delete(column, 'operator');
      }
    },
  }
}
</script>

<style scoped>

</style>
